/**
 * Tempo (em segundos) disponível para o cliente escanear o QR Code e concluir o
 * pagamento via Pix. Fonte única de verdade: é usado tanto para inicializar/rearmar
 * o contador em `Payment` quanto para exibir a mensagem em `PixPayment`.
 */
export const PIX_SCAN_TIME_SECONDS = 600; // 10 minutos
